import {
  BMComponentsType,
  BMElevationType,
  BMNavigationBar,
  BMPrimitives,
  useBMTheme,
} from "@traveloka/district-bloom";
import { useEffect, useMemo, useRef } from "react";
import { Animated, StyleSheet } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import BMView from "../../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../../core/resource/MobileResourceProvider";
import { FlightPrebookReviewModalComponentProps } from "../types";

export default function Header({
  animate,
  onClose = () => {},
}: Pick<FlightPrebookReviewModalComponentProps, "onClose"> & {
  animate: boolean;
}) {
  const { CorporateFlightGeneral: cr, CorporateFlightPrebookForm: crf } =
    useMobileContentResource();
  const { BMComponents, BMElevation } = useBMTheme();
  const styles = useMemo(
    () => createStyles(BMComponents, BMElevation),
    [BMComponents, BMElevation]
  );

  const insets = useSafeAreaInsets();
  const headerElevationOpacity = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.timing(headerElevationOpacity, {
      toValue: animate ? 1 : 0,
      duration: BMPrimitives.BMAnimation.duration.instant,
      useNativeDriver: true,
    }).start();
  }, [animate]);

  return (
    <BMView>
      <BMView style={[styles.container, { paddingTop: insets.top }]}>
        <BMNavigationBar
          title={crf.confirmationModalTitle}
          onCloseActionPress={onClose}
        />
      </BMView>
      <Animated.View
        pointerEvents="none"
        style={[styles.fakeShadow, { opacity: headerElevationOpacity }]}
      />
    </BMView>
  );
}

function createStyles(
  BMComponent: BMComponentsType,
  BMElevation: BMElevationType
) {
  return StyleSheet.create({
    container: {
      zIndex: 2,
      borderBottomWidth: BMPrimitives.BMBorder.width.thick,
      borderBottomColor: BMComponent.BMStyleLineBordercolorSubtle,
    },
    fakeShadow: {
      zIndex: 1,
      backgroundColor: "white",
      ...StyleSheet.absoluteFillObject,
      ...BMElevation.elevation2,
    },
  });
}
